// Worklist types based on backend WorklistView
export interface WorklistView {
  id: string;
  patient: string;
  account: string;
  serviceDate?: string | null;  // ISO date string
  physician: string;
  payer: string;
  admitType: string;
  admitSource: string;
}

// Available worklist types
export const WORKLIST_TYPES = [
  'Clinical Review',
  'Coding Review',
  'Clinical Denied',
  'Coding Denied',
  'Clinical Pending',
  'Coding Pending',
  'Clinical Approved',
  'Coding Approved',
  'Documents Needed',
  'Approved'
] as const;

export type WorklistType = typeof WORKLIST_TYPES[number];
